/**
 * German translations
 */
import type { Translations } from "./en";

export const de: Translations = {
  errors: {
    roomNoEmail: "Dieser Raum hat keine konfigurierte E-Mail-Adresse. Bitte kontaktieren Sie Ihren Administrator.",
    roomAlreadyBooked: "Dieser Raum ist für diesen Zeitraum bereits gebucht. Versuchen Sie einen anderen Raum.",
    bookingFailed: "Der Raum konnte nicht zum Termin hinzugefügt werden",
    networkError: "Überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, versuchen Sie sich neu zu verbinden.",
    authError: "Bitte melden Sie sich erneut an.",
    authRequired: "Authentifizierung erforderlich",
    authFailed: "Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    accountNotFound: "Kein Deskare-Konto ist mit der E-Mail {email} verknüpft. Bitte kontaktieren Sie Ihren Administrator.",
    userCancelled: "Die Anmeldung wurde abgebrochen. Versuchen Sie es erneut, wenn Sie bereit sind.",
    accountNotSupported: "Dieser Kontotyp wird nicht unterstützt. Bitte melden Sie sich mit einem Microsoft 365 Geschäfts- oder Schulkonto an.",
    popupBlocked: "Das Anmeldefenster wurde vom Browser blockiert. Erlauben Sie Popups für dieses Add-in und versuchen Sie es erneut.",
    consentRequired: "Eine Zustimmung des Administrators ist erforderlich. Bitten Sie Ihren Administrator, dieses Add-in freizugeben.",
    apiNotAvailable: "Der Microsoft Identitätsdienst ist in dieser Outlook-Version nicht verfügbar. Aktualisieren Sie Outlook und versuchen Sie es erneut.",
    validationError: "Bitte überprüfen Sie Ihre Daten und versuchen Sie es erneut.",
    unknownError: "Ein unerwarteter Fehler ist aufgetreten.",
    outlookContextUnavailable: "Der Office-Kontext ist nicht verfügbar",
    outlookNoAppointment: "Kein aktiver Termin",
    outlookCannotUpdateLocation: "Standort kann nicht aktualisiert werden",
    outlookCannotAddAttendee: "Teilnehmer kann nicht hinzugefügt werden",
    outlookCannotStoreData: "Daten können nicht gespeichert werden",
  },
  success: {
    roomAdded: "Der Raum wurde zu Ihrem Termin hinzugefügt.",
  },
  ui: {
    addRoom: "Raum hinzufügen",
    addingRoom: "Raum wird hinzugefügt...",
    addAnotherRoom: "Weiteren Raum hinzufügen",
    done: "Fertig",
    close: "Schließen",
    viewOtherRooms: "Andere Räume ansehen",
    searchRooms: "Räume suchen",
    reconnect: "Neu verbinden",
    roomFree: "Verfügbar",
    roomBooked: "Gebucht",
    roomAddedTitle: "Raum hinzugefügt!",
    roomAddedDescription: "Der Raum wurde zu Ihrem Termin hinzugefügt und als Ort festgelegt.",
    loadingAppointment: "Termindetails werden geladen...",
    filters: "Filter",
    minCapacity: "Mindestkapazität",
    equipment: "Ausstattung",
    noRoomsFound: "Keine Räume gefunden",
    adjustFilters: "Versuchen Sie die Filter anzupassen",
    roomFound: "Raum gefunden",
    roomsFound: "Räume gefunden",
    capacity: "Kapazität",
    attendee: "Teilnehmer",
    attendees: "Teilnehmer",
    tabsRooms: "Räume",
    tabsInsights: "Kontext",
    tabsShortlist: "Favoriten",
    meetingSummary: "Besprechungsübersicht",
    insightsTitle: "Besprechung vorbereiten",
    recommendedRooms: "Empfohlene Räume für diesen Zeitraum",
    timeWindow: "Zeitfenster",
    noShortlist: "Starten Sie eine Suche, um eine Auswahl vorzubereiten",
    recommendedForYou: "Für Sie empfohlen",
    refineSearch: "Suche verfeinern",
    people: "Personen",
    allRooms: "Alle Räume",
    loadingRooms: "Räume werden geladen...",
    tryAdjustFilters: "Versuchen Sie die Filter anzupassen",
    noSubject: "Kein Betreff",
    organizer: "Organisator",
    you: "Sie",
    location: "Ort",
    more: "weitere",
    confirmed: "Bestätigt",
    changeRoom: "Raum wechseln",
    cancelReservation: "Reservierung stornieren",
    loadingReservations: "Reservierungen werden geladen...",
    errorLoadingReservations: "Fehler beim Laden der Reservierungen",
    currentMeetingReservation: "Reservierung der aktuellen Besprechung",
    noReservations: "Keine Reservierungen",
    noReservationsDescription: "Sie haben keinen Raum für diese Besprechung gebucht",
    tabsBook: "Buchen",
    tabsReservations: "Meine Reservierungen",
    cancel: "Abbrechen",
    allOfficesLabel: "Alle Büros",
    office: "Büro",
    signOut: "Abmelden",
    signIn: "Anmelden",
    signedOutMessage: "Sie wurden abgemeldet.",
  },
  errorContext: {
    conflict: "Dieser Raum ist für diesen Zeitraum bereits gebucht. Versuchen Sie einen anderen Raum.",
    network: "Überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, versuchen Sie sich neu zu verbinden.",
    auth: "Bitte melden Sie sich erneut an.",
    validation: "Bitte überprüfen Sie Ihre Daten und versuchen Sie es erneut.",
  },
};
